<template>
  <div class="roomcreate">
    <section class="header">
        <div class="title">
            <span>채팅방 개설</span>
        </div>
        <div class="addRoom" @click="chatLobby">
            대기실로 나가기
        </div>
    </section>
    <section class="body">
      <!-- <component :is="activePage"></component> -->

      <!-- <form @submit.prevent="submitForm" >
        <div class="form-control">
          <label for="icon">아이콘</label>
          <input type="file" id="icon" @change="onFileChange" />
          <div id="preview">
            <img v-if="url" :src="url" width="55" height="65" />
          </div>
        </div>
        <div class="form-control">
          <label for="title">제목</label>
          <input type="text" id="title" v-model.trim="title" />
        </div>
        <div class="form-control">
          <label for="subtitle">부 제목</label>
          <input type="text" id="subtitle" v-model.trim="subtitle" />
        </div>
        <div class="form-control">
          <label for="max">최대인원</label>
          <input type="text" id="max" v-model.trim="max" />
        </div>
        <div class="form-control">
          <label for="limitation">레벨제한</label>
          <input type="text" id="limitation" v-model.trim="limitation" />
        </div>
        <div class="form-control">
          <label for="category">카테고리</label>
          <input type="text" id="category" v-model.trim="category" />
        </div>
        <base-button>{{ submitButtonCaption }}</base-button>
      </form> -->
      <chat-roomcreate-form @save-data="saveData"/>
    </section>
    <section class="footer">
        <copyright/>
    </section>
  </div>
</template>

<script>
import { chatroomcreate } from "@/components/mixins/chat/chatroomcreate.js";
export default {
  mixins:[chatroomcreate],
  data() {
    return {     
    };
  },  
  methods: {
   
  },
};
</script>

<style lang="scss" scoped>
.roomcreate{
    background:#fff;
    height:100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .header{
        line-height: 40px;
        background-color: #39302d;
        display: flex;
        font-size: 12px;
        color:#ffde00;
        font-weight: bold;
        justify-content: space-between;//꽉차가 화면 배분
        flex-wrap:wrap;//한줄에 가득차면 다음줄로
        .title{
            span{color:#fff;font-size: 12px;display: inline-block;padding-right: 10px;}
            padding-left: 10px;
        }
        .addRoom{
            padding-right:10px;
            cursor:pointer;
        }
    }
    .body{
        padding:50px;
    }
    .footer{
       background-color: #39302d;
       font-size:10px;
       color: #777371;
       font-family: Arial,Helvetica,sans-serif;
       line-height:20px
    }
}

</style>
